import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCliamInfoService } from "../../api/ropApi";

export const getCliamInfo = createAsyncThunk(
  "cliamInfo/getCliamInfo",
  async (data, { dispatch }) => {
    dispatch(resetReducer());
    const response = await getCliamInfoService(data);
    return response.data;
  }
);

const RopSlice = createSlice({
  name: "Rop",
  initialState: {
    cliamInfoLoader: false,
    cliamInfoData: null,
    status: null,
  },
  reducers: {
    resetReducer: (state) => {
      state.cliamInfoLoader = false;
      state.cliamInfoData = null;
      state.status = null;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCliamInfo.pending, (state, action) => {
        state.cliamInfoLoader = true;
        state.status = false;
      })
      .addCase(getCliamInfo.fulfilled, (state, action) => {
        state.cliamInfoData = action.payload.Body;
        state.cliamInfoLoader = false;
        state.status = true;
      })
      .addCase(getCliamInfo.rejected, (state, action) => {
        state.cliamInfoLoader = false;
        state.status = false;
      });
  },
});

export const { resetReducer } = RopSlice.actions;
export default RopSlice.reducer;
